import { useEffect, useMemo, useState } from "react";
import { useTagsList } from "../../../hooks/api/useTagsList";
import { useTranslation } from "react-i18next";
import urlApi from "shared/actions/urlApi";
import { API } from "@brg/api";

const useInitialCategories = (entityTypes: any, disable?: boolean) => {
  const { i18n: { language } } = useTranslation();

  const tagsFilter = useMemo(() => ({
    status: [0],
    ...(!!entityTypes?.tagIds?.length ? { emptyCategories: true } : { onlyCategories: true }),
    ...entityTypes,
  }), [entityTypes])

  const [tags, loadEn] = useTagsList({ ...tagsFilter },  language, 0, disable );

  return tags;
}



export { useInitialCategories } ;import { useEffect, useMemo, useState } from "react";
import { useTagsList } from "../../../hooks/api/useTagsList";
import { useTranslation } from "react-i18next";
import urlApi from "shared/actions/urlApi";
import { API } from "@brg/api";

const useInitialCategories = (entityTypes: any, disable?: boolean) => {
  const { i18n: { language } } = useTranslation();

  const tagsFilter = useMemo(() => ({
    status: [0],
    ...(!!entityTypes?.tagIds?.length ? { emptyCategories: true } : { onlyCategories: true }),
    ...entityTypes,
  }), [entityTypes])

  const [tags, loadEn] = useTagsList({ ...tagsFilter },  language, 0, disable );

  return tags;
}



export { useInitialCategories } ;